/**
 * The phone-width category navigation: a Browse button that opens the list of
 * collections in a drawer. Rendered by snippets/shop-category-navigation.liquid.
 *
 * The drawer is a native <dialog> opened with showModal, so Escape, the focus
 * trap and the backdrop are the browser's work rather than this file's. What is
 * left is opening it, closing it when the backdrop is clicked, keeping the
 * trigger's aria-expanded honest, and holding the page still while it is open —
 * showModal alone still lets the page behind scroll on iOS.
 */
class CollectionBrowse extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-browse-trigger]');
    this.drawer = this.querySelector('[data-browse-drawer]');

    if (!this.trigger || !this.drawer) return;

    this.trigger.addEventListener('click', () => this.open());

    this.querySelector('[data-browse-close]')?.addEventListener('click', () => this.drawer.close());

    // A click that lands on the dialog itself landed on its backdrop: the panel
    // inside covers every part of the dialog a pointer could otherwise reach.
    this.drawer.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.drawer.close();
    });

    // Fires however it closed — the close button, the backdrop, or Escape.
    this.drawer.addEventListener('close', () => {
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      this.trigger.focus();
    });
  }

  open() {
    this.drawer.showModal();
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }
}

customElements.define('collection-browse', CollectionBrowse);
